/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { Label, ParagraphWithTooltip, ImageWithFallback } from 'components';

export const ImgPreview = ({ selectedImg }) => {
  if (!selectedImg) return null;

  return (
    <Box>
      <NameBox>
        <Label text='File name:' variant='description' style={{ marginBottom: '8px' }} />
        <Container>
          <ParagraphWithTooltip text={selectedImg.file_name || selectedImg.name} />
        </Container>
      </NameBox>
      <ImgBox>
        <ImageWithFallback
          width='100%'
          src={`https://cdn.appnext.com/banner/${selectedImg.file_name}`}
        />
      </ImgBox>
    </Box>
  );
};

const Box = styled.div`
  border-left: 1px solid ${Palette.PrimaryGray._200};
  width: 248px;
  background: ${Palette.PrimaryGray._200};
  display: flex;
  flex-direction: column;
  height: calc(400px + 64px);
`;

const ImgBox = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 6px;
    background-color: ${Palette.PrimaryGray._000};
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

const NameBox = styled.div`
  padding: 24px;
  background: white;
`;

const Container = styled.div`
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: ${Palette.PrimaryGray._000};
  display: flex;
  align-items: center;
  height: 32px;
  padding: 4px 8px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04) inset;
`;
